import { forwardRef } from 'react';
import clsx from 'clsx';

export const Event3dButton = forwardRef<
	HTMLButtonElement,
	React.ComponentPropsWithRef<'button'>
>(function Event3dButton(
	{ 
		className, 
		children, 
		...buttonProps 
	},
	ref
) {
	return (
		<button 
			ref={ref}
			className={clsx('reward-btn-3d', className)} 
			type="button" 
			data-animate="false"
			{...buttonProps}
		>
			<span className="reward-btn-3d__text">{children}</span>
			<div className="reward-btn-3d__bg"></div>
		</button>
	);
});